// Verifies the user's bearer token against the Pluggz Supabase project.
import { createMiddleware } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { createClient } from "@supabase/supabase-js";

const PLUGGZ_URL = process.env.PLUGGZ_SUPABASE_URL ?? "https://kzdhvepwoytrhyjlriju.supabase.co";
const PLUGGZ_ANON = process.env.PLUGGZ_SUPABASE_ANON_KEY ?? "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt6ZGh2ZXB3b3l0cmh5amxyaWp1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMTc1MjEsImV4cCI6MjA5NjU5MzUyMX0.JZiBIXiixTKF8VuviLSEMSjqNuEQGMuJeRmBHQ0xuc8";

export const requireSupabaseAuth = createMiddleware({ type: "function" }).server(async ({ next }) => {
  const authHeader = getRequestHeader("authorization");
  if (!authHeader?.startsWith("Bearer ")) {
    throw new Response("Unauthorized: No authorization header provided", { status: 401 });
  }
  const token = authHeader.slice("Bearer ".length);

  const supabase = createClient(PLUGGZ_URL, PLUGGZ_ANON, {
    auth: { persistSession: false, autoRefreshToken: false },
    global: { headers: { Authorization: `Bearer ${token}` } },
  });

  const { data, error } = await supabase.auth.getUser(token);
  if (error || !data.user) {
    throw new Response("Unauthorized: Invalid token", { status: 401 });
  }

  return next({
    context: {
      supabase,
      userId: data.user.id,
      claims: (data.user.app_metadata ?? {}) as Record<string, unknown>,
    },
  });
});